/**
 * MIN-239: `/chat/$threadId`'s URL param must be validated before it reaches
 * `AgentChat.Root` or `setActiveThreadId` — an unvalidated param used to
 * render controlled on garbage and poison the shared `agentActiveThreadStore`
 * for the rest of the session.
 *
 * `ThreadId` is opaque (MIN-297) — the ai-engine's ids are non-negative
 * integers on the wire, so this still validates the digit-string shape, but
 * returns the id as the opaque string it already is rather than parsing it.
 * Returns `null` for anything else (non-numeric, non-integer, empty).
 */
export function parseThreadIdParam(param: string): string | null {
  if (!/^\d+$/.test(param)) return null;
  return param;
}
